export default __webpack_public_path__ + "static/media/bhbanner.cf735857.svg";